import script from "./SystemAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemAdmin.vue?vue&type=script&setup=true&lang=js"

import "./SystemAdmin.vue?vue&type=style&index=0&id=a4722044&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4722044"]])

export default __exports__